import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component,
  OnInit, AfterViewInit, ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import * as _ from 'lodash';
import { Observable } from 'rxjs';

import { BrandService } from 'shared/brand/brand.service';
import { PreferencesService } from 'shared/preferences/preferences.service';

import { InformationPageService } from '../../../information-page/information-page.service';
import { AccountInformationService } from '../../account-information.service';
import { BILLING_NAME } from '../../variables';

import { BaseAccountSegmentComponent } from '../base/_base-segment.component';
import { BillingFormComponent } from './billing-form/billing-form.component';
import { PlanInfoComponent } from './plan-info/plan-info.component';
import {ProductPanelComponent} from '../../../../product-panel/product-panel.component';


@Component({
  moduleId: module.id,
  selector: 'billing-segment',
  template: `
    <plan-info
      [brandId]="brandId"
      [timezone]='timezone'
      (subscriptionUpdated)='onSubscrUpdated()'></plan-info>
    <billing-form [brandId]="brandId" [timezone]='timezone'></billing-form>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class BillingComponent extends BaseAccountSegmentComponent implements OnInit, AfterViewInit {
  name: string = BILLING_NAME;
  brandId: string;
  timezone: string;

  @ViewChild(BillingFormComponent, {static: false})
  // @ts-ignore
  protected formComponent: BillingFormComponent | void;

  @ViewChild(PlanInfoComponent, {static: false})
  protected planInfoComponent: PlanInfoComponent | void;

  constructor(
    protected accountInformationService: AccountInformationService,
    protected informationPageService: InformationPageService,
    protected ref: ChangeDetectorRef,
    protected route: ActivatedRoute,
    protected location: Location,
    private brandService: BrandService,
    private preferencesService: PreferencesService,
  ) {
    super(
      accountInformationService,
      informationPageService,
      ref,
    );
  }

  /*******************************************
   * COMPONENT HOOKS
   *******************************************/

   ngOnInit() {
    super.ngOnInit();
    this.brandId = this.brandService.getBrand();
    this.preferencesService.getPreferences()
    .subscribe((preferences: any) => {
      this.timezone = preferences.timezone;
      this.ref.markForCheck();
    });

    this.ref.markForCheck();
  }

  ngAfterViewInit() {
    // https://speedlab.atlassian.net/browse/SPD2-2856
    // add manual call for billing - flow
    if (this.route.snapshot.params['flow'] === 'flow') {
      this.location.go('/account-information/billing');
      if (this.planInfoComponent) {
        this.planInfoComponent.startFlow();
      }
    }
  }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onSubscrUpdated() {
    if (this.formComponent) {
      this.formComponent.runSearch();
    }
  }
}
